<template>
  <div class="wrapper">
    <parallax
      class="section page-header header-filter"
      parallax-active="true"
      :style="headerStyle"
    >
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-66 md-small-size-100 mx-auto text-center"
          >
            <h1 class="title">
              {{ member.name }}
            </h1>
            <h4>
              If there are any errors in uneditable fields, please contact the AER secretariat.
            </h4>
          </div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section">
        <div class="container">
          <div class="md-layout py-5">
            <div class="md-layout-item md-size-100 mr-auto" style="margin-top: 1rem">
              <md-progress-bar md-mode="indeterminate" v-show="disableUi" class="md-primary"></md-progress-bar>
              <nav-tabs-card style="margin-top: 3rem">
                <template slot="content">
                  <md-tabs class="md-primary" md-alignment="left">
                    <template slot="md-tab" slot-scope="{ tab }">
                      <md-icon class="md-tab-icon" v-if="tab.icon">{{ tab.icon }}&nbsp;&nbsp;</md-icon>
                      {{ tab.label }} <i class="attention-needed md-primary" v-if="tab.data.warning"><md-icon style="color: red;">error</md-icon></i>
                    </template>
                    <md-tab id="tab-profile" md-label="Profile" md-icon="face" href="#profile">
                      <form @submit.prevent="submit">
                        <div class="md-layout">
                          <div class="md-layout-item md-medium-size-100 md-large-size-30" style="margin-bottom: 1rem;">
                            <div class="file-input">
                              <div v-if="member.image">
                                <div class="image-container">
                                  <img :src="member.image" />
                                </div>
                              </div>
                              <div class="image-container" v-else>
                                <img :src="default_image" />
                              </div>
                              <div class="image-message" style="margin: 1rem 0">
                                <div v-if="imageTip.message.length"><md-icon style="color: #ff9800">warning</md-icon>  {{ imageTip.message}}<hr></div>
                                <div v-html="imageTip.defaultMessage"></div>
                              </div>
                              <div class="button-container">
                                <div v-if="disableUi">
                                  <p>Loading...</p>
                                </div>
                                <div v-else>
                                  <md-button
                                    class="md-danger md-round"
                                    @click="removeImage"
                                    v-if="member.image"
                                  >
                                    <i class="fa fa-times" />
                                    Remove
                                  </md-button>
                                  <md-button class="md-success md-fileinput">
                                    <template v-if="!member.image">Upload Image</template>
                                    <template v-else>Change</template>
                                    <input type="file" @change="onFileChange" />
                                  </md-button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="md-layout-item md-medium-size-100 md-large-size-70">
                            <div class="md-layout-item md-size-100">
                              <md-field class="md-invalid">
                                <label>Salutation</label>
                                <md-input 
                                  v-model="member.salutation" readonly
                                />
                              </md-field>
                            </div>
                            <div class="md-layout-item md-size-100">
                              <md-field class="md-invalid">
                                <label>Name</label>
                                <md-input 
                                  v-model="member.name" 
                                  :disabled="disableUi"
                                />
                                <validation-error :errors="apiValidationErrors.name" />
                              </md-field>
                            </div>
                            <div class="md-layout-item md-size-100">
                              <md-field class="md-invalid">
                                <label>Sex</label>
                                <md-select  
                                  v-model="member.sex" 
                                  :disabled="disableUi"
                                >
                                  <md-option value="male">Male</md-option>
                                  <md-option value="female">Female</md-option>
                                </md-select>
                                <validation-error :errors="apiValidationErrors.sex" />
                              </md-field>
                            </div>
                            <div class="md-layout-item md-size-100">
                              <md-field class="md-invalid">
                                <label>Degree</label>
                                <md-input 
                                  v-model="member.degree"
                                  :disabled="disableUi"
                                />
                              </md-field>
                            </div>
                            <div class="md-layout-item md-size-100">
                              <md-field class="md-invalid">
                                <label>Disciplines</label>
                                <md-input :value="displayDisciplines(member.disciplines)" readonly></md-input>
                              </md-field>
                            </div>
                            <div class="md-layout-item md-size-100">
                              <md-field class="md-invalid">
                                <label>Specializations</label>
                                  <md-select
                                    v-model="specializations"
                                    @md-selected="updateSpecialization"
                                    name="disciplines"
                                  :disabled="disableUi"
                                    multiple
                                  >
                                    <md-option
                                      v-for="specialization in specializationList"
                                      :key="'specialization_' + specialization.id"
                                      :value="specialization.id"
                                    >
                                      {{ specialization.name }}
                                    </md-option>
                                  </md-select>
                                <validation-error :errors="apiValidationErrors.specializations" />
                              </md-field>
                            </div>
                            <div class="md-layout-item md-size-100">
                                <md-datepicker  
                                  v-model="member.date_of_birth" 
                                  :disabled="disableUi"

                                >
                                  <label>Date of Birth</label>
                                </md-datepicker>
                            </div>
                            <div class="md-layout-item md-size-100">
                              <md-field class="md-invalid md-has-value">
                                <label>Profile Url</label>
                                <span class="prefix">https://aer.afeo.org/@</span>
                                <md-input 
                                  v-model="member.alias" 
                                  :disabled="disableUi"
                                />
                                <span class="alias-validation" :class="{'success': aliasOk, 'error': !aliasOk}">
                                  <md-icon v-if="aliasOk">check</md-icon>
                                  <span v-else>
                                    <md-icon>warning</md-icon>
                                    <span class="validation-text">Profile URL Exists</span>
                                  </span>
                                </span>
                                <validation-error :errors="apiValidationErrors.alias" />
                              </md-field>
                            </div>
                            <div class="md-layout-item md-size-100">
                              <country-select v-model="member.country" 
                                  :disabled="disableUi"></country-select>
                            </div>

                            <div class="md-layout-item md-size-100">
                              <md-field class="md-invalid">
                                <label>Employer</label>
                                <md-input 
                                  v-model="member.employer" 
                                  :disabled="disableUi"
                                />
                                <validation-error :errors="apiValidationErrors.employer" />
                              </md-field>
                            </div>
                            <div class="md-layout-item md-size-100">
                              <md-field class="md-invalid">
                                <label>Consented to Publish Data</label>
                                <md-select  
                                  v-model="member.consent" 
                                  :disabled="disableUi"
                                >
                                  <md-option value="yes">Yes</md-option>
                                  <md-option value="no">No</md-option>
                                </md-select>
                                <validation-error :errors="apiValidationErrors.sex" />
                              </md-field>
                            </div>
                            <div class="md-layout-item md-size-100 text-right">
                                <md-button type="submit" class="md-success">
                                  <span v-if="this.disableUi">
                                  <i class="fas fa-spinner fa-spin"></i>&nbsp;&nbsp;
                                  </span>
                                  <span v-else>
                                    Update Profile
                                  </span>
                                </md-button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </md-tab>
                    <md-tab id="tab-experience" md-label="Experience" md-icon="work" href="#experience">
                      <form @submit.prevent="updateExperience">
                        <div class="md-layout">
                          <div class="md-layout-item md-size-50">
                            <md-field class="md-invalid md-has-value">
                              <label>Years of Professional Working Experience (as of date of admission)</label>
                              <div style="width: 30px;">
                                <md-input 
                                    v-model="member.years_ppwe" 
                                    type="number"
                                />
                              </div>
                              <span class="suffix" style="margin-top: 6px;">years</span>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-size-50">
                            <md-field class="md-invalid md-has-value">
                              <label>Years of Significant Working Experience (as of date of admission)</label>
                              <div style="width: 30px;">
                                <md-input 
                                    v-model="member.years_swe" 
                                    type="number"
                                />
                              </div>
                              <span class="suffix" style="margin-top: 6px;">years</span>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-size-100">
                            <h3 style="margin-bottom: 0;">Description of your professional experience</h3>
                            <p style="color: #999; font-style: italic; margin-top: 0">
                              <span>Textarea will automatically expand with more lines</span>
                            </p>
                            <md-field>
                              <ckeditor
                                :editor="editor"
                                v-model="member.experience"
                                :config="editorConfig"
                              ></ckeditor>
                              <validation-error :errors="apiValidationErrors.experience" />
                            </md-field>
                          </div>
                          <div class="md-layout-item md-size-100">
                            <h3 style="margin-bottom: 0;">Description of your skills &amp; specialization</h3>
                            <p style="color: #999; font-style: italic; margin-top: 0">
                              <span>Textarea will automatically expand with more lines</span>
                            </p>
                            <md-field>
                              <ckeditor
                                :editor="editor"
                                v-model="member.specialization"
                                :config="editorConfig"
                              ></ckeditor>
                              <validation-error :errors="apiValidationErrors.specialization" />
                            </md-field>
                          </div>
                          <div class="md-layout-item md-size-100 text-right clear">
                            <div>
                              <md-button type="submit" class="md-success">Update Experience</md-button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </md-tab>
                    <md-tab id="tab-contact" md-label="Contact" md-icon="contact_mail" href="#contact" :md-template-data="{ warning: (member.contacts.length == 0)}">
                      <p class="text-left">
                        This information is not visible to the public. The contact form on your profile page will send an e-mail to your primary e-mail address if available. 
                        Otherwise information here is only accessible by the AER Secretariat.
                        <br /><br />
                      </p>
                      <div id="form-member-contacts" class="md-layout">
                        <div class="md-layout-item md-small-size-100 md-size-50">
                          <md-card>
                            <md-card-header class="md-card-header-icon md-card-header-primary">
                              <div class="card-icon">
                                <md-icon>email</md-icon>
                              </div>
                              <h4 class="title">Email Addresses</h4>
                            </md-card-header>
                            <md-card-content>
                              <md-table
                                :value="contacts.emails"
                                class="table-striped table-hover"
                                table-header-color="green"
                              >
                                <md-table-empty-state>
                                  <div class="text-center">
                                    <md-icon  style="color: red">error</md-icon> Please add an e-mail address
                                  </div>
                                </md-table-empty-state>
                                <md-table-row slot="md-table-row" slot-scope="{ item }">
                                  <md-table-cell style="width: 15%;">
                                    <b>{{ item.label }}</b>
                                  </md-table-cell>
                                  <md-table-cell style="width: 55%;">
                                    {{ item.data.email }}
                                    <span v-if="item.is_primary">
                                      <md-icon style="color: #ffc107;">star</md-icon>
                                    </span>
                                  </md-table-cell>
                                  <md-table-cell style="width: 30%;">
                                    <md-button class="md-just-icon md-raised md-round md-info" @click="editEmail(item)" style="margin: .2rem;">
                                      <md-icon>edit</md-icon>
                                    </md-button>
                                    <md-button class="md-just-icon md-raised md-round md-danger" @click="deleteEmail(item)" style="margin: .2rem;">
                                      <md-icon>delete</md-icon>
                                    </md-button>
                                  </md-table-cell>
                                </md-table-row>
                              </md-table>

                              <div class="text-center" style="padding-bottom: 0.5rem 0;">
                                <md-button class="md-success" @click="addEmail">Add E-mail</md-button>
                              </div>
                            </md-card-content>
                          </md-card>
                        </div>
                        <div class="md-layout-item md-small-size-100 md-size-50">
                          <md-card>
                            <md-card-header class="md-card-header-icon md-card-header-primary">
                              <div class="card-icon">
                                <md-icon>phone</md-icon>
                              </div>
                              <h4 class="title">Phone</h4>
                            </md-card-header>
                            <md-card-content>
                              <md-table
                                :value="contacts.numbers"
                                class="table-striped table-hover"
                                table-header-color="green"
                              >
                                <md-table-empty-state>
                                  <div class="text-center">
                                    <md-icon  style="color: red">error</md-icon> Please add a phone number
                                  </div>
                                </md-table-empty-state>
                                <md-table-row slot="md-table-row" slot-scope="{ item }">
                                  <md-table-cell style="width: 23%;">
                                    <b>{{ item.label }}</b>
                                  </md-table-cell>
                                  <md-table-cell style="width: 2%; text-align: center;">
                                    <i :class="'fa fa-'+getPhoneIcon(item.data.type)" style="font-size: 18px;">
                                      <md-tooltip md-direction="bottom">{{item.data.type}}</md-tooltip>
                                    </i>
                                  </md-table-cell>
                                  <md-table-cell style="width: 55%;">
                                    {{ item.data.number.match(/.{1,3}/g).join(' ') }}
                                    <span v-if="item.is_primary">
                                      <md-icon style="color: #ffc107;">star</md-icon>
                                    </span>
                                  </md-table-cell>
                                  <md-table-cell style="width: 30%;">
                                    <md-button class="md-just-icon md-raised md-round md-info" @click="editPhone(item)" style="margin: .2rem;">
                                      <md-icon>edit</md-icon>
                                    </md-button>
                                    <md-button class="md-just-icon md-raised md-round md-danger" @click="deletePhone(item)" style="margin: .2rem;">
                                      <md-icon>delete</md-icon>
                                    </md-button>
                                  </md-table-cell>
                                </md-table-row>
                              </md-table>
                              <div class="text-center" style="padding-bottom: 0.5rem 0;">
                                <md-button class="md-success" @click="addPhone">Add Phone Number</md-button>
                              </div>
                            </md-card-content>
                          </md-card>
                        </div>
                        <div class="md-layout-item md-small-size-100 md-size-100">
                          <md-card>
                            <md-card-header class="md-card-header-icon md-card-header-primary">
                              <div class="card-icon">
                                <md-icon>home</md-icon>
                              </div>
                              <h4 class="title">Mailing Address</h4>
                            </md-card-header>
                            <md-card-content>
                              <md-table
                                :value="contacts.addresses"
                                class="table-striped table-hover"
                                table-header-color="green"
                              >
                                <md-table-empty-state>
                                  <div class="text-center">
                                    <md-icon  style="color: red">error</md-icon> Please add a mailing address
                                  </div>
                                </md-table-empty-state>
                                <md-table-row slot="md-table-row" slot-scope="{ item }">
                                  <md-table-cell style="width: 15%;">
                                    <b>{{ item.label }}</b>
                                  </md-table-cell>
                                  <md-table-cell style="width: 65%;">
                                    {{ displayAddress(item.data) }}
                                    <span v-if="item.is_primary">
                                      <md-icon style="color: #ffc107;">star</md-icon>
                                    </span>
                                  </md-table-cell>
                                  <md-table-cell style="width: 20%;">
                                    <md-button class="md-just-icon md-raised md-round md-info" @click="editAddress(item)" style="margin: .2rem;">
                                      <md-icon>edit</md-icon>
                                    </md-button>
                                    <md-button class="md-just-icon md-raised md-round md-danger" @click="deleteAddress(item)" style="margin: .2rem;">
                                      <md-icon>delete</md-icon>
                                    </md-button>
                                  </md-table-cell>
                                </md-table-row>
                              </md-table>
                              <div class="text-center" style="padding-bottom: 0.5rem 0;">
                                <md-button class="md-success" @click="addAddress">Add Mailing Address</md-button>
                              </div>
                            </md-card-content>
                          </md-card>
                        </div>
                      </div>   
                    </md-tab>
                    <md-tab id="tab-security" md-label="Security" md-icon="vpn_key"  href="#security" :md-template-data="{ warning: (member.noPassword)}">
                      <form @submit.prevent="changePassword">
                        <div class="md-layout">
                          <div class="md-layout-item md-size-20 md-small-size-100" style="margin-bottom: 1rem;">
                            <md-field class="md-invalid">
                              <label>Password</label>
                              <md-input 
                                v-model="password" 
                                type="password"
                              />
                            <span v-if="(password.length && password_confirmation.length) && disablePwChangeBtn" class="md-error">Password must match!</span>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-size-20 md-small-size-100" style="margin-bottom: 1rem;">
                            <md-field>
                              <label>Password Confirmation</label>
                              <md-input 
                                v-model="password_confirmation" 
                                type="password"
                              />
                            </md-field>
                          </div>
                          <div class="md-layout-item md-size-20 md-small-size-100" style="margin-bottom: 1rem;">
                          </div>
                          <div class="md-layout-item md-size-100 text-right">
                            <md-button type="submit" class="md-success" :disabled="disablePwChangeBtn">Update Password</md-button>
                          </div>
                        </div>
                      </form>
                    </md-tab>

                    <md-tab id="tab-resources" md-label="Resources" md-icon="newspaper"  href="#resources" :md-template-data="{ warning: (member.noPassword)}">
                      <div class="md-layout">
                          <div class="md-layout-item text-left">
                            <p> 
                              Here are some resources which you may find useful as part of your membership. 
                            </p>
                            <ul>
                              <li> 
                                <a href="https://bit.ly/34WZX3H" target="_blank">
                                e-Library
                                </a> 
                              </li>
                            </ul>
                          </div>
                      </div>
                    </md-tab>
                  </md-tabs>
                </template>
              </nav-tabs-card>
            </div>
            <div class="md-layout-item md-size-100 mr-auto text-center" style="margin-bottom: 1rem" @click="logout">
              <md-button class="md-danger">Logout</md-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br /><br />
  </div>
</template>

<script>
import { ProfileCard,FancyCard,NavTabsCard,ValidationError } from "@/components";
import CountrySelect from '@/components/Inputs/CountrySelect.vue';
import formMixin from "@/mixins/form-mixin";
import Mixins from "@/plugins/basicMixins";
import {format} from 'date-fns';
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditor from "@ckeditor/ckeditor5-vue";
import Swal from "sweetalert2";

export default {
  name: "Profile",
  components: {
    NavTabsCard,ValidationError,CountrySelect,
    ckeditor: CKEditor.component
  },
  mixins: [Mixins.HeaderImage, formMixin],
  bodyClass: "profile-page",
  data() {
    return {
      member: {
        type: "profile",
        salutation: 'Ir.',
        name: "Loading...",
        gender: "male",
        country: "my",
        email: "loading@example.com",
        mobile: "",
        mheo_id: "00000",
        mheo: "iem",
        mheo_year: "",
        degree: "Loading...",
        date_of_birth: new Date("1985-12-31"),
        degree_year: "2015",
        discipline: "Loading...",
        disciplines: [],
        license: "",
        license_year: "",
        years_ppwe: 0,
        years_swe: 0,
        employer: "Loading...",
        specialisation: "Loading...",
        specialisations: [],
        experience: "",
        consent: false,
        contacts: [],
      },
      image: require("@/assets/img/city-profile.jpg"),
      cardFullBg: {
          fullBg1: require("@/assets/img/examples/mariya-georgieva.jpg"),
          fullBg2: require("@/assets/img/examples/clem-onojeghuo.jpg"),
          fullBg3: require("@/assets/img/examples/olu-eletu.jpg"),
          fullBg4: require("@/assets/img/examples/floralia.jpg")
      },
      cardProfile3: {
          cardProfile1: require("@/assets/img/alex.jpg"),
          cardProfile2: require("@/assets/img/faces/marc.jpg"),
          cardProfile3: require("@/assets/img/faces/kendall.jpg"),
          cardProfile4: require("@/assets/img/faces/card-profile2-square.jpg")
      },
      disciplines: [],
      disciplineList: [],
      specializations: [],
      specializationList: [],

      countryList: [],

      profileImage: {
        size: 0,
        width: 0,
        height: 0
      },
      imageTip: {
        active: false,
        message: '',
        defaultMessage: 'Image should be no more than <b>2MB</b> and <b>1280px</b> in width&height'
      },
      imgMaxWidth: 1280,
      imgMaxHeigth: 1280,
      imgMaxSize: 2097152,
      file: null,
      default_image: require("@/assets/img/no-picture.gif"),
      disableUi: true,
      password: '',
      password_confirmation: '',
      notification: {
        duration: 100000,
        show: false,
        level: 'success',
        icon: 'fa-check',
        message: 'Test'
      },
      aliasOk: true,
      disablePwChangeBtn: true,
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          "heading",
          "|",
          "bold",
          "italic",
          "bulletedList",
          "numberedList",
          "blockQuote",
          "Outdent",
          "Indent"
        ],
      },

      contacts: {
        emails: [],
        numbers: [],
        addresses: []
      }
    };
  },
  watch: {
    'member.alias': function( newVal, oldVal) {
      this.$store.dispatch("me/checkAlias", newVal)
      .then(() => {
      });
    },
    'password': function( newVal, oldVal ) {
      if ( newVal != this.password_confirmation ) {
        this.disablePwChangeBtn = true;
      } else {
        this.disablePwChangeBtn = false;
      }
    },
    'password_confirmation': function( newVal, oldVal ) {
      if ( newVal != this.password) {
        this.disablePwChangeBtn = true;
      } else {
        this.disablePwChangeBtn = false;
      }
    }
  },
  created() {
    this.specializationList = this.$store.getters["options/specializations"];

    this.$store.dispatch("me/getProfile")
      .then(() => {
        this.member = this.$store.getters["me/profile"];
        this.member.type = "profile";
        this.parseContacts(this.member);


        this.member.specializations.forEach((specialization) => {
          this.specializations.push(specialization.id);
        });

        this.$store.dispatch('alerts/success', 'Profile loaded').then(() => this.loading(false));

      }, error => {
        this.$store.dispatch('alerts/error', 'Failed to load profile').then(() => this.loading(true));
        this.$router.push('login');
      });
  },
  methods: {
    loading(disableUi) {
      this.disableUi = disableUi;
    },
    logout() {
      this.$store.dispatch('logout');
      this.$router.push('login');
    },
    updateSpecialization() {
      this.member.specializations = [];
      this.specializations.forEach((specialization) => {
        this.member.specializations.push({
          id: specialization,
          type: "specializations",
        });
      });
    },
    async getCountries() {
      await this.$store.dispatch("countries/list").then( () => {
      });

    },
    async submit() {
      try {
        this.loading(true);
        this.$store.dispatch("me/update", this.member).then(() => {
          this.$store.dispatch('alerts/success', 'Profile updated!').then(() => {
            this.loading(false);
          })
        });
      } catch (e) {
        if(e?.response?.data.errors?.[0]) {
          this.setApiValidation(e.response.data.errors);
        } else {
          await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
        }
        this.showProgressBar = false;
      }

      try {
        if (this.file) {
          // upload logo and get image url
          this.$store.dispatch("me/upload", {member: this.member, image: this.file}).then(() => {
            this.$store.dispatch('alerts/success', 'Image updated!')
          });
        }
      } catch (e) {
        e.response.data.errors.forEach(error => {
          this.$store.dispatch("alerts/error", error.detail);
        })
        this.loading(false);
      }
    },
    async updateExperience() {
      try {
        this.loading(true);
        await this.$store.dispatch("me/update", this.member).then(() => {
          this.$store.dispatch('alerts/success', 'Experience updated!').then(() => {
            this.loading(false);
          })
        });

      } catch (e) {
        if(e?.response?.data.errors?.[0]) {
          this.setApiValidation(e.response.data.errors);
        } else {
          await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
          this.loading(false);
        }
        this.showProgressBar = false;
      }
    },
    changePassword() {
      try {
        this.$store.dispatch("me/password", {
          type: 'members',
          password: this.password,
          password_confirmation: this.password_confirmation
        }).then(() => {
          this.password = '';
          this.password_confirmation = '';
          this.$store.dispatch('alerts/success', 'Password changed!').then(() => this.loading(false));
        }, error => {
        });

        
      } catch (e) {
          this.$store.dispatch('alerts/error', 'Could not change password').then(() => this.loading(false));
      }
    },
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;

      this.createImage(files[0]);
    },
    createImage(file) {
      try {
        this.imageTip.active = false;

        if ( file.size > 1024*1024*2 ) {
          this.$store.dispatch('alerts/error', 'Image has to be smaller than 2MB');
          return;
        }

        let img = new Image();
        img.src = file;

        let reader = new FileReader();
        reader.onload = (e) => {
          let img = new Image();
          img.src = e.target.result;
          this.file = file;

          if ( img.width > 1280 || img.height > 1280 ) { 
            this.$store.dispatch('alerts/error', 'Image has to be smaller than 1280px in width or height');
            return;
          }

          if ( img.width / img.height != 1 ) {
            this.imageTip.active = true;
            this.imageTip.message = "Image height and width should be equal, otherwise resizing might distort the image";
          }
          this.member.image = e.target.result;
        };
        reader.readAsDataURL(file);
      } catch (e) {
        this.$store.dispatch('alerts/error', e);
      }
    },
    removeImage() {
      this.member.image = null;
      this.imageTip.active = false;
    },
    displayDisciplines(list) {
      return Array.prototype.map.call(list, s => s.name).join(", ");
    },

    parseContacts(profile) {
      profile.contacts.forEach((item) => {
        if ( item.type == 'email' ) {
          this.contacts.emails.push(item);
        }
        if ( item.type == 'phone' ) {
          this.contacts.numbers.push(item);
        }
        if ( item.type == 'address' ) {
          this.contacts.addresses.push(item);
        }
      });
    },
    getPhoneIcon(type) {
      switch (type ) {
        case 'mobile': 
          return 'mobile-alt';
        case 'fax': 
          return 'fax';
        case 'landline': 
        default: 
          return 'phone';
      }
    },
    displayAddress(address) {
      let lines = [];
      lines.push(address.line1);
      if ( address?.line2?.length > 0 ) { 
        lines.push(address.line2);
      } 
      if ( address?.line3?.length > 0 ) { 
        lines.push(address.line3);
      } 
      lines.push(address.postcode+' '+address.city);
      lines.push(address.state);
      lines.push(address.country);

      return lines.join(', ');
    },
    buildAddressForm(item) {
      let html = '<div class="swal2-input-row"><label for="address-label"class="swal2-input-label">Label*</label><input id="address-label" value="'+(item?.label ?? '')+'" class="swal2-input" required="required"></div>'+
        '<div class="swal2-input-row"><label for="address-line1" class="swal2-input-label">Line 1*</label><input id="address-line1" value="'+(item?.data?.line1 ?? '')+'" class="swal2-input" required="required"></div>'+
        '<div class="swal2-input-row"><label for="address-line2" class="swal2-input-label">Line 2</label><input id="address-line2" value="'+(item?.data?.line2 ?? '')+'" class="swal2-input"></div>'+
        '<div class="swal2-input-row"><label for="address-line3" class="swal2-input-label">Line 3</label><input id="address-line3" value="'+(item?.data?.line3 ?? '')+'" class="swal2-input"></div>'+
        '<div class="swal2-input-row"><label for="address-city" class="swal2-input-label">City*</label><input id="address-city" value="'+(item?.data?.city ?? '')+'" class="swal2-input" required="required"></div>'+
        '<div class="swal2-input-row"><label for="address-postcode" class="swal2-input-label">Postcode*</label><input id="address-postcode" value="'+(item?.data?.postcode ?? '')+'" class="swal2-input" required="required"></div>'+
        '<div class="swal2-input-row"><label for="address-state" class="swal2-input-label">State*</label><input id="address-state" value="'+(item?.data?.state ?? '')+'" class="swal2-input" required="required"></div>'+
        '<div class="swal2-input-row"><label for="address-country" class="swal2-input-label">Country*</label><input id="address-country" value="'+(item?.data?.country ?? '')+'" class="swal2-input" required="required"></div>'+
        '<div class="swal2-input-row"><label for="address-primary" class="swal2-input-label">Primary</label><input id="address-primary" class="swal2-input" type="checkbox" value="1"'+( (item.is_primary == 1 ) ? ' checked="checked"' : '' )+' style="width: 2em; height: 1.8em; margin-top: 0.5em;"></div>';

      return html;
    },
    async addAddress() {
      const updated = await Swal.fire({
        title: "Add Address",
        html: this.buildAddressForm({}),
        focusConfirm: false,
        preConfirm: async () => {
          try {
            let newItem = {
              type: 'contacts',
              label: document.getElementById('address-label').value,
              is_primary: document.getElementById('address-primary').checked,
              method: 'address',
              data: {
                line1: document.getElementById('address-line1').value ?? '',
                line2: document.getElementById('address-line2').value ?? '',
                line3: document.getElementById('address-line3').value ?? '',
                city: document.getElementById('address-city').value ?? '',
                postcode: document.getElementById('address-postcode').value ?? '',
                state: document.getElementById('address-state').value ?? '',
                country: document.getElementById('address-country').value ?? ''
              }
            };

            let address = await this.$store.dispatch("me/addContact", newItem).then((response) => {
              this.$store.dispatch('alerts/success', newItem.label+" Address added successfully.").then(() => { 
                this.addContactItem(this.contacts.addresses, response);
              });
            });
          } catch (e) {
            let error = '"Oops, something went wrong!';
            if(e?.response?.data?.errors[0]) {
              error = e.response.data.errors[0].detail;
            } else if ( e?.swal2 ) {
              error = e.swal2;
            } else {
            }

            Swal.showValidationMessage(error);
          }
        },
        showCancelButton: true,
        confirmButtonText: "Add",
        cancelButtonText: "Cancel",
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button",
      })
    },
    async editAddress(item) {
      const updated = await Swal.fire({
        title: "Update "+item.label+" Address",
        html: this.buildAddressForm(item),
        focusConfirm: false,
        preConfirm: async () => {
          try {
            let newItem = {
              type: 'contacts',
              id: item.id,
              label: document.getElementById('address-label').value,
              is_primary: document.getElementById('address-primary').checked,
              method: 'address',
              data: {
                line1: document.getElementById('address-line1').value,
                line2: document.getElementById('address-line2').value,
                line3: document.getElementById('address-line3').value,
                city: document.getElementById('address-city').value,
                postcode: document.getElementById('address-postcode').value,
                state: document.getElementById('address-state').value,
                country: document.getElementById('address-country').value
              }
            };

            let address = await this.$store.dispatch("me/updateContact", newItem).then((response) => {
              this.$store.dispatch('alerts/success', item.label+" Address updated successfully.").then(() => { 
                this.updateContactItem(this.contacts.addresses, response);
              });
            });


          } catch (e) {
            let error = '"Oops, something went wrong!';
            if(e?.response?.data?.errors[0]) {
              error = e.response.data.errors[0].detail;
            } else {
            }

            Swal.showValidationMessage(error);
          }
        },
        showCancelButton: true,
        confirmButtonText: "Update",
        cancelButtonText: "Cancel",
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button",
      });
    },
    async deleteAddress(item) {
      let code = item.label;
      const deleted = await Swal.fire({
        title: "Delete "+item.label+" address?",
        text: "To delete, enter the following code: "+code,
        input: "text",
        inputValidator: (value) => {
          return new Promise((resolve) => {
            if ( value === code ) {
              resolve(); 
            } else {
              resolve('Incorrect code');
            }
          });
        },
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
      })
      
      if (deleted.value === code) {
        try {
          await this.$store.dispatch("me/deleteContact", item.id).then(response => {
            this.$store.dispatch('alerts/success', item.label+" Address removed successfully.").then(() => {
              this.removeContactItem(this.contacts.addresses, item.id);
            });
            this.$emit('deleted', item);
          });
        } catch (e) {
          if(e.response.data.errors[0]) {
            message = e.response.data.errors[0].title;
          } else {
            message = "Oops, something went wrong!";
          }
          this.$store.dispatch('alerts/error', message);
        }
      }
    },

    buildEmailForm(item) {
      
      let html = '<div class="swal2-input-row"><label for="email-label"class="swal2-input-label">Label</label><input id="email-label" value="'+(item?.label ?? '')+'" class="swal2-input" required="required"></div>'+
        '<div class="swal2-input-row"><label for="email-email" class="swal2-input-label">E-mail</label><input id="email-email" type="email" value="'+(item?.data?.email ?? '')+'" class="swal2-input" required="required"></div>'+
        '<div class="swal2-input-row"><label for="email-primary" class="swal2-input-label">Primary</label><input id="email-primary" class="swal2-input" type="checkbox" value="1"'+( (item.is_primary == 1 ) ? ' checked="checked"' : '' )+' style="width: 2em; height: 1.8em; margin-top: 0.5em;"></div>';

      return html;
    },
    async addEmail() {
      const updated = await Swal.fire({
        title: "Add E-mail",
        html: this.buildEmailForm({}),
        focusConfirm: false,
        preConfirm: async () => {
          try {
            let newItem = {
              type: 'contacts',
              memberId: this.id,
              label: document.getElementById('email-label').value,
              is_primary: document.getElementById('email-primary').checked,
              method: 'email',
              data: {
                email: document.getElementById('email-email').value ?? '',
              }
            };

            let email = await this.$store.dispatch("me/addContact", newItem).then((response) => {
              this.$store.dispatch('alerts/success', newItem.label+" E-mail added successfully.").then(() => {
                this.addContactItem(this.contacts.emails, response)
              });
            });


          } catch (e) {
            let error = '"Oops, something went wrong!';
            if(e?.response?.data?.errors[0]) {
              error = e.response.data.errors[0].detail;
            } else if ( e?.swal2 ) {
              error = e.swal2;
            } else {
            }

            Swal.showValidationMessage(error);
          }
        },
        showCancelButton: true,
        confirmButtonText: "Add",
        cancelButtonText: "Cancel",
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button",
      })
    },
    async editEmail(item) {
      const updated = await Swal.fire({
        title: "Update "+item.label+" E-mail",
        html: this.buildEmailForm(item),
        focusConfirm: false,
        preConfirm: async () => {
          try {
            let newItem = {
              type: 'contacts',
              id: item.id,
              label: document.getElementById('email-label').value,
              is_primary: document.getElementById('email-primary').checked,
              method: 'email',
              data: {
                email: document.getElementById('email-email').value ?? '',
              }
            };
            this.$store.dispatch("me/updateContact", newItem).then((response) => {
              this.$store.dispatch('alerts/success', newItem.label+" E-mail updated successfully.").then(() => {
                this.updateContactItem(this.contacts.emails, response)
              }); 
            });

          } catch (e) {
            let error = '"Oops, something went wrong!';
            if(e?.response?.data?.errors[0]) {
              error = e.response.data.errors[0].detail;
            } else {
            }

            Swal.showValidationMessage(error);
          }
        },
        showCancelButton: true,
        confirmButtonText: "Update",
        cancelButtonText: "Cancel",
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button",
      });
    },
    async deleteEmail(item) {
      let code = item.label;
      const deleted = await Swal.fire({
        title: "Delete "+item.label+" e-mail?",
        text: "To delete, enter the following code: "+code,
        input: "text",
        inputValidator: (value) => {
          return new Promise((resolve) => {
            if ( value == code ) {
              resolve(); 
            } else {
              resolve('Incorrect code');
            }
          });
        },
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
      })
      
      if (deleted.value == code) {
        try {
          await this.$store.dispatch("me/deleteContact", item.id).then(response => {
            this.$store.dispatch('alerts/success', item.label+" E-mail removed successfully.").then(() => {
              this.removeContactItem(this.contacts.emails, item.id)
            });
            this.$emit('deleted', item);
          });
        } catch (e) {
          if(e.response.data.errors[0]) {
            message = e.response.data.errors[0].title;
          } else {
            message = "Oops, something went wrong!";
          }
          this.$store.dispatch('alerts/error', message)
        }
      }
    },
    addContactItem(contactList, newItem) {
      contactList.forEach((item, index, arr) => {
        if ( newItem.is_primary == true ) { 
          arr[index].is_primary = false;
        }
      });
      contactList.push(newItem)
    },
    updateContactItem(contactList, newItem) {
      contactList.forEach((item, index, arr) => {
        if ( newItem.is_primary == true ) { 
          arr[index].is_primary = false;
        }
        if ( newItem.id == item.id ) {
          this.$set(arr, index, newItem);
        }
      });
    },
    removeContactItem(contactList, id) {
      contactList.forEach((item, index, arr) => {
        if ( id == item.id ) {
          arr.splice(index, 1);
        }
      });
    },
    buildPhoneForm(item) {;
      let types = {
        mobile: {
          label: "Mobile",
          value: 'mobile',
          selected: false
        },
        landline: {
          label: "Land line",
          value: 'landline',
          selected: false
        },
        fax: {
          label: "Fax",
          value: 'fax',
          selected: false
        }
      };

      if ( item?.data?.type ) {
        types[item.data.type].selected = true;
      }

      let options = "";
      for ( const type in types ) {
        options += '<option value="'+types[type].value+'"'+(types[type].selected ? ' selected="selected"' : '')+'>'+types[type].label+'</option>';
      }

      let html = '<div class="swal2-input-row"><label for="phone-label"class="swal2-input-label">Label</label><input id="phone-label" value="'+(item?.label ?? '')+'" class="swal2-input" required="required"></div>'+
        '<div class="swal2-input-row"><label for="phone-type" class="swal2-input-label">Type</label><select id="phone-type" class="swal2-input">'+options+'</select></div>'+
        '<div class="swal2-input-row"><label for="phone-number" class="swal2-input-label">Number</label><input id="phone-number" value="'+(item?.data?.number ?? '')+'" class="swal2-input" required="required"></div>'+
        '<div class="swal2-input-row"><label for="phone-primary" class="swal2-input-label">Primary</label><input id="phone-primary" class="swal2-input" type="checkbox" value="1"'+( (item.is_primary == 1 ) ? ' checked="checked"' : '' )+' style="width: 2em; height: 1.8em; margin-top: 0.5em;"></div>';

      return html;
    },
    async addPhone() {
      const updated = await Swal.fire({
        title: "Add Phone",
        html: this.buildPhoneForm({}),
        focusConfirm: false,
        preConfirm: async () => {
          try {
            let newItem = {
              type: 'contacts',
              label: document.getElementById('phone-label').value,
              is_primary: document.getElementById('phone-primary').checked,
              method: 'phone',
              data: {
                type: document.getElementById('phone-type').value ?? '',
                number: document.getElementById('phone-number').value ?? '',
              }
            };

            let email = await this.$store.dispatch("me/addContact", newItem).then((response) => {
              this.$store.dispatch('alerts/success', newItem.label+" Phone Number added successfully.").then(() => {
                this.addContactItem(this.contacts.numbers, response)
              });
            });


          } catch (e) {
            let error = '"Oops, something went wrong!';
            if(e?.response?.data?.errors[0]) {
              error = e.response.data.errors[0].detail;
            } else if ( e?.swal2 ) {
              error = e.swal2;
            } else {
            }

            Swal.showValidationMessage(error);
          }
        },
        showCancelButton: true,
        confirmButtonText: "Add",
        cancelButtonText: "Cancel",
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button",
      })
    },
    async editPhone(item) {
      const updated = await Swal.fire({
        title: "Update "+item.label+" Phone",
        html: this.buildPhoneForm(item),
        focusConfirm: false,
        preConfirm: async () => {
          try {
            let newItem = {
              type: 'contacts',
              id: item.id,
              label: document.getElementById('phone-label').value,
              is_primary: document.getElementById('phone-primary').checked,
              method: 'phone',
              data: {
                type: document.getElementById('phone-type').value ?? '',
                number: document.getElementById('phone-number').value ?? '',
              }
            };

            let email = await this.$store.dispatch("me/updateContact", newItem).then((response) => {
              this.$store.dispatch('alerts/success', newItem.label+" Phone Number updated successfully.").then(() => {
                this.updateContactItem(this.contacts.numbers, response)
              });
            });

          } catch (e) {
            let error = '"Oops, something went wrong!';
            if(e?.response?.data?.errors[0]) {
              error = e.response.data.errors[0].detail;
            } else {
            }

            Swal.showValidationMessage(error);
          }
        },
        showCancelButton: true,
        confirmButtonText: "Update",
        cancelButtonText: "Cancel",
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button",
      });
    },
    async deletePhone(item) {
      let code = item.data.type+"-"+item.label;
      const deleted = await Swal.fire({
        title: "Delete "+item.label+" phone?",
        text: "To delete, enter the following code: "+code,
        input: "text",
        inputValidator: (value) => {
          return new Promise((resolve) => {
            if ( value === code ) {
              resolve(); 
            } else {
              resolve('Incorrect code');
            }
          });
        },
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
      })
      
      if (deleted.value === code) {
        try {
          await this.$store.dispatch("me/deleteContact", item.id).then(response => {
            this.$store.dispatch('alerts/success', item.label+" Phone Number removed successfully.").then(() => {
              this.removeContactItem(this.contacts.numbers, item.id)
            });
            this.$emit('deleted', item);
          });
        } catch (e) {
          if(e.response.data.errors[0]) {
            message = e.response.data.errors[0].title;
          } else {
            message = "Oops, something went wrong!";
          }
          this.$store.dispatch('alerts/error', message);
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/material-kit/_variables";

.section {
  padding: 0;
}

.profile-tabs::v-deep {
  .md-card-tabs .md-list {
    justify-content: center;
  }

  [class*="tab-pane-"] {
    margin-top: 3.213rem;
    padding-bottom: 50px;

    img:not(.img) {
      margin-bottom: 2.142rem;
    }
  }
}

.md-input:read-only {
  background: #eee;
  cursor: default;
}
.md-focused .md-input:read-only {
  border-bottom-color: -internal-light-dark(rgb(118, 118, 118), rgb(133, 133, 133));
}

.md-snackbar.md-theme-default {
  &.success {
    background: $brand-success;
  }
  &.error {
    background: $brand-danger;
  }
  &.warning {
    background: $brand-warning;
  }
  &.info {
    background: $brand-info;
  }

    .md-button {
      color: #333;
      background: #eee !important;
    }
}

.md-snackbar-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.alias-validation {
  font-size: 12px;
  background: transparent;

  &.error {
    .md-icon, .validation-text {
      color: $brand-danger;
    }
  }
  &.success {
    .md-icon, .validation-text {
      color: $brand-success;
    }
  }
}
#form-member-contacts {
  .md-table thead, .md-table tfoot {
    display: none;
  }

  .md-card {
    .md-card-header-icon {
      padding: 0.25rem 0;
      .card-icon, .title {
        display: inline-block;
        padding: 0 0.2rem;
      }
      .title {
        margin: 0;
        padding-top: 5px;
        font-size: 1rem;;
      }
      .card-icon i {
        color: $white-color;
        padding-bottom: 5px;
      }
    }
  }
}

.swal2-input-row {
  float: left;
  width: 100%;
  clear: both;
  font-size: 0.8em;
  margin-bottom: 0.4em;

  .swal2-input-label {
    display: block;
    padding: 1em 0;
    float: left;
    width: 25%;
    text-align: left;
    font-weight: bold;
  }

  .swal2-input {
    float: left; 
    width: 75%;
    margin: 0;
  }
}
</style>

<style>
.ck.ck-editor {
  width: 100%;
}
.ck-editor__editable {
  min-width: 100%;
  min-height: 480px;
}


</style>